import React from "react";
import {
  Grid,
  Box,
  withStyles,
  withWidth,
} from "@material-ui/core";
import HenigLoader from "../../../shared/components/HenigLoader";
import styled from "styled-components";
import useEventListener from './../../../shared/functions/useEventListener';
import ArrowButtonLink from 'shared/components/ArrowButtonLink';

import { useDispatch, useSelector } from "react-redux";
import { setAnimationStarted } from "./../../../redux/actions/home";

import { Link } from "react-router-dom";
import numeral from 'numeral';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as AuthActions from "./../../../redux/actions/auth";
import { isOtherShape } from 'logged_out/components/diamonds/All';
import getSymbolFromCurrency from 'currency-symbol-map';
import Button from "@material-ui/core/Button";
import FadeIn from 'shared/components/FadeIn';
import { convertToCurrency } from 'shared/functions/priceCalc';
import ButtonCircularProgress from "shared/components/ButtonCircularProgress";
// import GIF from 'shared/functions/gif';

const SkipButton = styled(props => <ArrowButtonLink {...props} />)`
    position: absolute;
    bottom: 48px;
    right: 50px;
    z-index: 1;
    margin: 140px 0 0 69px;
    opacity: 0.5;
    border: solid 1px #ccced3;
    height: 33px;
    width: 111px;
    display: flex;
    justify-content: center;
`;

const styles = (theme) => ({
  extraLargeButtonLabel: {
    fontSize: theme.typography.body1.fontSize,
    [theme.breakpoints.up("sm")]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  extraLargeButton: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.up("xs")]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  card: {
    boxShadow: theme.shadows[4],
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("xs")]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(5.5),
      paddingBottom: theme.spacing(5.5),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
    [theme.breakpoints.down("lg")]: {
      width: "auto",
    },
  },
  wrapper: {
    position: "relative",
    backgroundColor: theme.palette.secondary.dark,
    paddingBottom: theme.spacing(2),
    //height: 'calc(100vh - 145px)'
    height: '100vh'
  },
  image: {
    maxWidth: "100%",
    verticalAlign: "middle",
    borderRadius: theme.shape.borderRadius,
    /* boxShadow: theme.shadows[4], */
  },
  container: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(9),
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  containerFix: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "none !important",
    },
  },
  videoAnimationWrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    zIndex: 1,
    opacity: 0,
    transitionDuration: '2s',
    backgroundColor: 'black',
    backgroundImage: 'url(/images/particles+flare@2x.jpg)',
    //backgroundSize: '100%',
    backgroundSize: '250%',
    backgroundPosition: 'center',
  },
  videoLoopWrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    zIndex: 1,
    transitionDuration: '4s',
    backgroundColor: 'black',
    backgroundImage: 'url(/images/particles+flare@2x.jpg)',
    backgroundSize: '250%',
    backgroundPosition: 'center',
  },
});

const CallToActionsWrap = styled.div`
align-items: center;
transition: opacity 3s ease-out;
transition-delay: 15s;
opacity: 0;
bottom: 130px;
position: absolute;
left: 50%;
transform: translateX(-50%);
display: flex;
margin: -16px;

button {
    margin: 16px;
    height: 33px;
    width: 111px;
    min-width: max-content;
    padding: 0;
    font-family: Lato;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: normal;
    text-align: center;
    text-transform: none;
    color: #b08f6e;
    background-color: #ffffff;
    border: solid 1px #b6b8bc;
    box-shadow: none !important;
    border-radius: 0;
    padding-left: 10px;
    padding-right: 10px;

    &:hover {
        background-color: #EEEEEE;
    }

    &.MuiButton-containedSecondary {
        color: #ffffff !important;
        border: solid 1px #b08f6e;
        background-color: #b08f6e;
    }

    &:disabled{
        opacity: 0.8;
    }
  }

.separator-text{
  text-transform: uppercase;
  color: #585858;
  font-size: 12px;
}
`;

const transitionTimingFunction = `cubic-bezier(.77,0,.37,1)`;
const transitionDuration = `2s`;

const videoTransitionStyle = { transitionTimingFunction, transitionDuration };

const HenigLogoImg = styled.img`
  position: absolute;
  z-index: 1;
  top: 6%;
  height: 20%;
  left: 0px;
  width: 100%;
  object-fit: contain;
  transition-timing-function: ${transitionTimingFunction}; /* https://cubic-bezier.com/#.77,0,.37,1 */
  transition-duration: ${transitionDuration};
`;
const HenigLogo = (props) => (
  <HenigLogoImg {...props} src={'/images/logo@3x.png'} />
);

const HeadlineMessageWrap = styled.h3`
  width: 100%;
  height: 60px;
  font-family: MinionPro-Disp;
  font-size: 62px;
  font-weight: normal !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.92;
  letter-spacing: 1px;
  text-align: center;
  color: #484f57;
  position: absolute;
  bottom: 94px;
  transition-duration: 1.5s;
  padding: 0;
  margin: 0;

  .text-style-1 {
    color: #e3e3e3;
  }

  @media (max-width: 882px){
    font-size: 50px;
  }
  @media (max-width: 716px){
    font-size: 40px;
  }
  @media (max-width: 599px){
    font-size: 62px;
  }
`;
const HeadlineMessage = (props) => (
  <HeadlineMessageWrap {...props}>
    <span className="text-style-1">Every</span> <span>facet of the</span> <span className="text-style-1">Diamond</span> <span>Industry</span>
  </HeadlineMessageWrap>
);

const SpecialOffer = styled.div`
  width: auto;
  height: 88px;
  background-color: #24272b;
  position: absolute;
  z-index: 1;
  padding-left: 40px;
  padding-right: 30px;
  bottom: 0;

  opacity: 0.1;
  left: -100%;
  transition: left 2s ease-in-out, opacity 2s ease-in-out 0.6s;

  h3{
    font-family: Lato;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: 1.44px;
    text-align: left;
    color: #b6b8bc;
    margin-top: -25px;
  }

  img{
    cursor: pointer;
  }
  .specialOfferText{
    font-family: Lato;
    font-size: 13px;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.92;
    letter-spacing: normal;
    text-align: left;
    color: #f8f9fa;
    margin-right: 8px;
  
    h4{
      font-size: 13px;
      margin: 0;
      margin-bottom: 8px;
      font-weight: 100;
    }
    p{
      font-family: Lato;
      font-size: 11px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: left;
      color: #8d9298;
      margin: 0;

      .specialOffersTextSeparator{
        width: 1px;
        height: 14px;
        background-color: #8d9298;
        display: inline-block;
        margin-left: 6px;
        margin-right: 6px;
        vertical-align: middle;
      }
    }
  }

/* Safari-Opera specific declarations here */
@media screen and (-webkit-min-device-pixel-ratio:0) {
  
  .MuiGrid-spacing-xs-2 {
    width: calc(100% + 33px);
  }
  .MuiGrid-container {
    flex-wrap: nowrap;
  }

}
`;

const ScrollDownIndicator = styled((props) => <a {...props}><svg xmlns="http://www.w3.org/2000/svg" width="10.723" height="6.524" viewBox="0 0 10.723 6.524">
  <g>
    <path fill="none" stroke="#b6b8bc" d="M0 0l4.993 5.447L9.985 0" transform="translate(.369 -11.136) translate(0 11.474)" />
  </g>
</svg></a>)`
  position: absolute;
  z-index: 1;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  padding: 10px;

  transition-duration: 2s;
  opacity: 0;
`;

function HeadSection(props) {

  const { diamondsDocs = [], ccy, fxrates = [], openEmailDialog } = props;

  function joinHenigArray(d, field) {
    return [d[field][0].From, d[field][1].To].filter(s => s).join(' to ')
  }

  let tileData = diamondsDocs.filter(a => a.WebSpecial);

  let isSpecialOffers = true;

  // if no special offers, load all
  if (tileData.length === 0) {
    tileData = diamondsDocs.filter(d => d.StkCatType === 'Single Item');
    isSpecialOffers = false;
  }

  tileData = tileData.slice(0, 3).map(d => {
    const isParcel = d.StkCatType === 'Multiple Items';
    d.WebSpecial = parseFloat(d.WebSpecial)
    const price = d.WebSpecial || (isParcel ? d.ppc : d.price) || d.ExWebTotal;
    return {
      ...d,
      img: `/images/${isOtherShape(isParcel, d.StkShape) ? 'round' : d.StkShape.toLowerCase()}${isParcel ? '_parcel.png' : '.png'}`,
      priceEl: <h4>{getSymbolFromCurrency(ccy) + numeral(Math.round(convertToCurrency(price, isParcel, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small className="text-style-1">{numeral(Math.round(convertToCurrency(price, isParcel, fxrates, ccy))).format('0,0.00').split('.')[1]}</small></h4>,
      subtitle: <p>{isParcel ? d.size || '-' : `${numeral(d.STWeight).format('0.00')}ct`} <span className="specialOffersTextSeparator" /> {joinHenigArray(d, 'Colour') || '-'} <span className="specialOffersTextSeparator" /> {joinHenigArray(d, 'Clarity') || '-'}</p>,
    }
  });


  const { classes, headSectionAnimationComplete } = props;

  const [videoAnimation, setVideoAnimation] = React.useState(true);
  const [videoAnimationRef, setVideoAnimationRef] = React.useState(null);
  const [screenDimensions, setScreenDimensions] = React.useState({ height: window.innerHeight, width: window.innerWidth });
  const [videoProps, setVideoProps] = React.useState({});
  const [videoLoading, setVideoLoading] = React.useState(true);
  const [videoLoopRef, setVideoLoopRef] = React.useState(null);

  const [videoLoop, setVideoLoop] = React.useState(false);
  const [showHeadlineMessage, setShowHeadlineMessage] = React.useState(false);
  const [moveLogoUp, setMoveLogoUp] = React.useState(false);
  const [fadeOutLogo, setFadeOutLogo] = React.useState(false);
  const [moveHeadlineMessage, setMoveHeadlineMessage] = React.useState(false);
  const [animateParticles, setAnimateParticles] = React.useState(false);

  const skipIntro = () => {
    setVideoLoading(false)
    setVideoAnimation(false)
    setVideoLoop(true)
    setShowHeadlineMessage(true)
    setMoveLogoUp(true)
    setAnimateParticles(true)
    setMoveHeadlineMessage(true)
    setFadeOutLogo(true);
    headSectionAnimationComplete();
  }

  const hasAnimationStarted = useSelector((state) => state.home.animationStarted);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (!hasAnimationStarted) {
      dispatch(setAnimationStarted());
    }
  }, [dispatch]);

  // keep track of window resize:
  React.useEffect(() => {
    function handleResize() {
      setScreenDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
    }

    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  });

  const handler = React.useCallback((e) => {
    if (!hasAnimationStarted) {
      setTimeout(() => {
        setVideoLoading(false)
        setVideoProps(e)
        e.target.play()
      }, 2000);
    } else {
      setVideoProps(e)
      skipIntro()
    }
  }, [setVideoProps]);

  // wait for video to be able to play (we can also get video dimensions)
  useEventListener('canplay', handler, videoAnimationRef);
  useEventListener('canplay', handler, videoLoopRef);


  useEventListener('timeupdate', function (e) {
    if (!videoLoop && e.target.currentTime > 5) {
      setVideoLoop(true)
    }
    if (e.target.currentTime > 6) {
      setShowHeadlineMessage(true)
    }
    if (e.target.currentTime > 8) {
      setMoveLogoUp(true)
    }
    if (e.target.currentTime > 8.5) {
      setAnimateParticles(true)
    }
    if (e.target.currentTime > 9) {
      setMoveHeadlineMessage(true)
    }
    if (e.target.currentTime > 10) {
      setFadeOutLogo(true);
      headSectionAnimationComplete();
    }
  }, videoAnimationRef);

  let newVideoWidth = 0;
  let newVideoHeight = 0;
  let newVideoMarginTop = 0;
  let newVideoMarginLeft = 0;
  const videoStyle = {
    mixBlendMode: 'exclusion',
    backgroundImage: 'url(/images/particles+flare@2x.jpg)'
  };
  const videoZoom = 1.70;
  screenDimensions.height = window.innerHeight; // calculate based on the container's height.

  if (videoProps && videoProps.target) {
    var ratio = 0;
    var videoWidth = videoProps.target.videoWidth;
    var height = videoProps.target.videoHeight;

    ratio = screenDimensions.height / height;
    newVideoHeight = screenDimensions.height;
    newVideoWidth = videoWidth * ratio;
    videoWidth = videoWidth * ratio;
    height = height * ratio;
    newVideoMarginLeft = -((newVideoWidth - screenDimensions.width) / 2);

    // Check if the current videoWidth is larger than the max
    /* if(videoWidth > screenDimensions.width){
        ratio = screenDimensions.width / videoWidth;   // get ratio for scaling video
        newVideoWidth = screenDimensions.width; // Set new videoWidth
        newVideoHeight = height * ratio;  // Scale height based on ratio
        height = height * ratio;    // Reset height to match scaled video
        videoWidth = videoWidth * ratio;    // Reset videoWidth to match scaled video
    } */

    // code to keep the video width always as large as the screen so we don't leave empty areas
    if (newVideoWidth < screenDimensions.width) {
      ratio = screenDimensions.width / videoWidth;
      newVideoWidth = screenDimensions.width;
      newVideoMarginLeft = 0;
      newVideoHeight = height * ratio;
    }

    // calculate dimensions and position based on zoom
    newVideoWidth *= videoZoom;
    newVideoHeight *= videoZoom;
    newVideoMarginLeft = -((newVideoWidth - screenDimensions.width) / 2);
    newVideoMarginTop = -((newVideoHeight - screenDimensions.height) / 2);

    videoStyle.width = newVideoWidth;
    videoStyle.height = newVideoHeight;
    videoStyle.marginLeft = newVideoMarginLeft;
    videoStyle.marginTop = newVideoMarginTop;

    if (moveLogoUp) {
      videoStyle.width = '170vw';
      videoStyle.height = '140vh';
      videoStyle.marginTop = '-30vh'; // 1440 
      videoStyle.marginLeft = '-35vw'; // 1440 
      //videoStyle.marginTop = '-10%'; // 2560 
    }
  }

  let henigLogoStyle = {}
  if (moveLogoUp) {
    henigLogoStyle = { top: 6, height: 46 };
  }
  if (fadeOutLogo) {
    henigLogoStyle = { ...henigLogoStyle, opacity: 0 };
  }

  return (
    <div id={props.id} style={{ height: screenDimensions.height, position: 'relative', zIndex: 0, backgroundColor: 'black' }}>

      <HenigLoader open={videoLoading} />

      {videoAnimation &&
        <div className={classes.videoAnimationWrapper} style={videoLoading ? null : { opacity: 1 }}>
          <video muted ref={setVideoAnimationRef} style={videoStyle}>
            <source src={'/videos/Startup_8bit.mp4'} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
        </div>
      }

      <div className={classes.videoLoopWrapper} style={{ opacity: videoLoop ? 1 : 0 }}>
        {videoLoop && <div>
          <video autoPlay muted loop style={{ ...videoStyle, ...videoTransitionStyle }} ref={setVideoLoopRef}>
            <source src={'/videos/Rot_converted.mp4'} type="video/mp4" />
              Your browser does not support the video tag.
          </video>

          <HenigLogo style={henigLogoStyle} />

          <HeadlineMessage style={{ opacity: showHeadlineMessage ? 1 : 0, bottom: moveHeadlineMessage ? 195 : null }} />

          {!props.isAuthorised &&
            <CallToActionsWrap style={{ opacity: showHeadlineMessage ? 1 : 0 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => document.location.hash = '#register'}
              >
                Register
              </Button>
              <span className="separator-text">or</span>
              <Button
                variant="contained"
                color="default"
                onClick={() => openEmailDialog()}
              >
                Login
              </Button>
            </CallToActionsWrap>
          }
        </div>
        }

      </div>

      <SpecialOffer style={moveHeadlineMessage ? { opacity: 1, left: 0 } : null}>
        <h3>{isSpecialOffers ? 'SPECIAL OFFERS' : 'LATEST ARRIVALS'}</h3>

        <Box mt={4}>
          <Grid container alignItems="center" spacing={3}>
            <Grid item>
              <a href={'/#special-offers'}>
                <img alt="" src={'/images/icon_down@3x.png'} width={10} />
              </a>
            </Grid>
            {tileData.map((tile, k) => <Grid item key={k}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item style={{ paddingLeft: 5 }}>
                  <Link to={`/diamonds/${tile._id}/details`}>
                    <img alt="" className="diamond-img" src={(tile.img) || ''} width={35} />
                  </Link>
                </Grid>
                <Grid item style={{ paddingLeft: 0 }}>
                  <div className={'specialOfferText'}>
                    {isSpecialOffers ? tile.priceEl : props.isAuthorised ? tile.priceEl : ''}
                    {tile.subtitle}
                  </div>
                </Grid>
              </Grid>
            </Grid>)}
          </Grid>
        </Box>
      </SpecialOffer>

      <ScrollDownIndicator style={moveHeadlineMessage ? { opacity: 1 } : null} href={'/#about-us'} />

      {!fadeOutLogo && <SkipButton label={'Skip'} onClick={() => skipIntro()} />}

    </div >
  );
}


const MobileWrapper = styled.div`
  background-color: black;
  max-width: 100%;
  height: 100vh;
  img{
    object-fit: cover;
    width: 100%;
  }
`;

const MobileHeadlineMessage = styled(HeadlineMessage)`
  position: relative;
  width: 100vw;
  text-align: center;
  bottom: 60px;
  margin: auto;

  span{
    width: 100vw;
    display: block;
    margin-bottom: 15px;
    font-size: 40px;
  }
`;

/* 
const GifCanvas = ({src, style}) => {

  const canvasRef = React.useRef();
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    if(!canvasRef.current) return; 

    let myGif;
    const gifURL = src; // Can not load gif cross domain unless it has CORS header
    const ctx = canvasRef.current.getContext("2d");
  
    // timeout just waits till script has been parsed and executed
    // then starts loading a gif
    setTimeout(()=>{
        myGif = GIF();                  // creates a new gif  
        myGif.onerror = function(e){
          console.log("Gif loading error " + e.type);
        }
        myGif.load(gifURL);  
    }, 10); 
  
    // Function draws an image
    function drawImage(image,x,y,scale,rot){
        ctx.setTransform(scale,0,0,scale,x,y);
        ctx.rotate(rot);
        ctx.drawImage(image,-image.width / 2, -image.height / 2);
    }
  
    var w = canvasRef.current.width;
    var h = canvasRef.current.height / 100 * 60;
    var cw = w / 2; // center 
    var ch = h / 2;
  
    // main update function
    function update(timer) {

      const innerWidth = window.innerWidth;
      const innerHeight = window.innerHeight  / 100 * 60;

      ctx.setTransform(1, 0, 0, 1, 0, 0); // reset transform
      if (w !== innerWidth || h !== innerHeight) {
        cw = (w = canvasRef.current.width = innerWidth) / 2;
        ch = (h = canvasRef.current.height = innerHeight) / 2;
      } else {
        ctx.clearRect(0, 0, w, h);
      }
      if(myGif) { // If gif object defined
        if(!myGif.loading){  // if loaded
            // displays the current frame.
            drawImage(myGif.image,cw,ch,0.7,0); 
            if(loading) setLoading(false);
        }else if(myGif.lastFrame !== null){  
            // Shows frames as they load
            //ctx.drawImage(myGif.lastFrame.image,0,0); 
        }
      
      }else{
          // waiting for GIF image...
      }
      requestAnimationFrame(update);
    }
    update();
  }, [canvasRef.current]);

  return <React.Fragment>
    {loading && <div style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <ButtonCircularProgress style={{padding: 0}} />
    </div>}
    <canvas ref={canvasRef} style={{...style, opacity: loading ? 0 : 1}} />
  </React.Fragment>;
} 
*/

const SectionWrapper = (props) => {
  if (props.width === 'xs') {
    props.headSectionAnimationComplete();
    return <MobileWrapper>
      <FadeIn delay={1000} duration={1000}>
        {/* <GifCanvas src="/images/Henig_Mobile_Rota.gif" style={{ transitionDuration: '1.5s' }} /> */}
        {/* <img src="/images/Henig_Mobile_Rota.gif" style={{ transitionDuration: '1.5s' }} /> */}
        <img src="/images/Henig_Mobile.png" style={{ transitionDuration: '1.5s' }} />
      </FadeIn>
      <FadeIn delay={2000} duration={2000}>
        <MobileHeadlineMessage />
      </FadeIn>
    </MobileWrapper>
  } else {
    return <HeadSection {...props} />
  }
}

export default React.memo(connect(
  (state) => ({
    authUser: state.auth.user,
    isAuthorised: state.auth.isAuthorised,
    diamondsDocs: state.diamonds.data && state.diamonds.data.docs || [],
    ccy: state.site.ccy,
    fxrates: state.site.fxrates,
  }),
  (dispatch) => ({
    AuthActions: bindActionCreators({ ...AuthActions }, dispatch)
  })
)(withWidth()(withStyles(styles, { withTheme: true })(SectionWrapper))));